module.exports = __webpack_public_path__ + "img/personal_like_active.b30db30a.png";